import * as React from "react";
import Odometer from "react-odometerjs";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { BannerImages } from "source/app/services/Shared/RenderSwal/BannerImage/BannerImage";
import RenderSwal from "source/app/services/Shared/RenderSwal/RenderSwal";
import styled from "styled-components";
import { Sounds } from "../../../../services/Sound/Sounds";
import { IKeyValueLogsState } from "../IKeyValueLogsState";
import { ShowEmotionValues } from "./Grouped/ShowEmotionValues";

export function ShowRecentEmotionsPercentValue({
    state,
}: {
    state: IKeyValueLogsState;
}) {
    if (state.percentValue === null || state.percentValue === 0) {
        return null;
    }

    return (
        <span
            onMouseEnter={() =>
                Sounds.ambientHalo.Play({ loop: false, allowConcurrent: true })
            }
        >
            <Hyperlink
                whenClicked={() => {
                    Sounds.chimes_varied_long.Play();
                    RenderSwal(
                        {
                            bannerImage: BannerImages.cherish,
                            height: `400px`,
                        },
                        <ShowEmotionValues />,
                        () => {}
                    );
                }}
            >
                <StyledText>
                    <PrimaryMetric>
                        <OdometerWrapper>
                            <Odometer value={state.percentValue} />
                        </OdometerWrapper>
                    </PrimaryMetric>
                </StyledText>
            </Hyperlink>
        </span>
    );
}

const OdometerWrapper = styled.span`
    filter: brightness(1.3);
    font-size: 14px;
    font-variant-numeric: tabular-nums;
    justify-self: center;
    line-height: 12px;
    text-shadow:
        0 1px 2px rgba(0, 0, 0, 0.95),
        0 0 2px currentColor;
    -webkit-text-stroke: 0.5px rgba(0, 0, 0, 0.9);
`;

const StyledText = styled.div`
    font-size: 11px;
    font-variant-numeric: tabular-nums;
`;

const PrimaryMetric = styled.div`
    display: flex;
    justify-content: center;
    width: 336px;
`;
